import { AiOutlineClose } from "react-icons/ai";
import {
  CancelBtn,
  Header,
  MediumContainer,
  NextBtn,
} from "../../../screens/User/Users/components/IncidentType/incident.style";
import { useIncidentData } from "../../../layouts/incidentLayout";
import { handleDeleteDrafts } from "./methodsAndHandlers";
import { useFormikContext } from "formik";
import { useIncidentFormContext } from "./IncidentContext";

interface IDeleteDraftProps {
  closeDeleteModal: (x: boolean) => void;
}

const DeleteDraft = ({ closeDeleteModal }: IDeleteDraftProps) => {
  const { allFormFields, _handleDiscard } = useIncidentFormContext();
  const { deleteIncidentLoading, deleteMutateAsync } = useIncidentData();

  const formik = useFormikContext<{ [x: string]: any }>();

  async function _handleDeleteDrafts() {
    handleDeleteDrafts(
      formik.values,
      allFormFields,
      _handleDiscard,
      deleteMutateAsync
    );
  }

  const handleModalClose = () => {
    closeDeleteModal(false);
  };

  return (
    <MediumContainer>
      <div className="flex">
        <div
          onClick={handleModalClose}
          style={{ fontSize: "30px", cursor: "pointer" }}
        >
          <AiOutlineClose size={25} />
        </div>
        <Header>Delete Draft?</Header>
      </div>
      <p className="text-md px-5 py-5 text-center">
        Are you sure you want to delete this draft?
      </p>

      <div className="mb-14 mr-7 mt-5">
        <NextBtn onClick={_handleDeleteDrafts} disabled={deleteIncidentLoading}>
          Delete
        </NextBtn>
        <CancelBtn onClick={handleModalClose}>Cancel</CancelBtn>
      </div>
    </MediumContainer>
  );
};

export default DeleteDraft;
